import { Map } from 'immutable';
import { connect } from '../../../../common/react-redux';
import { ItemFeedbackModal as ItemFeedbackModalPresenter } from './presenter';
import { closeModal } from '../../../../common/actions/modal';
import { changeItemFeedback } from '../../../../common/actions/modifications';
import Item from '../../../../common/records/Item';
import { set } from '../../../../common/actions/ui';
import { getModalTrigger } from '../../../../common/util/modalHelpers';
import { generateImportModalId } from '../../../../common/components/ImportModal';
import { ITEM_FEEDBACK_MODAL, ITEM_FEEDBACK_MODAL_ITEM, ITEM_FEEDBACK_MODAL_FEEDBACK } from '@instructure/quiz-common';
function mapStateToProps(state, props) {
  var nestedModals = ['correct', 'incorrect', 'neutral'].map(generateImportModalId);
  var openModal = state.getIn(['modal', 'isOpen']);
  var importModalOpen = nestedModals.includes(openModal);
  return {
    importModalOpen: importModalOpen,
    modalOpen: openModal === ITEM_FEEDBACK_MODAL,
    item: new Item(state.getIn(['ui', ITEM_FEEDBACK_MODAL_ITEM])),
    feedback: state.getIn(['ui', ITEM_FEEDBACK_MODAL_FEEDBACK]) || Map(),
    modalTrigger: getModalTrigger(state)
  };
}
var mapDispatchToProps = {
  closeModal: closeModal,
  changeItemFeedback: changeItemFeedback,
  setUi: set
};
export var ItemFeedbackModal = connect(mapStateToProps, mapDispatchToProps)(ItemFeedbackModalPresenter);
export default ItemFeedbackModal;